(function () {
	document.addEventListener('shopify:section:load', function () {
		const slider = new Swiper('.js-media-list', getSliderSettings);

		const subSlider = new Swiper('.js-media-sublist', getSubSliderProductSettings);

		setTimeout(function () {
			slider.update();
			subSlider.update();
		}, 100)
	});
})();


function getSelectedColor() {
  // 1) Check for radio buttons (variant-radios or product-form)
  const checkedRadio =
    document.querySelector('variant-radios input[type="radio"]:checked') ||
    document.querySelector('.product-form input[type="radio"]:checked')

  if (checkedRadio && checkedRadio.value) {
    return checkedRadio.value.trim()
  }

  // 2) Check for dropdown/select
  const firstSelect = document.querySelector("variant-selects select") || document.querySelector(".product-form select")

  if (firstSelect && firstSelect.value) {
    return firstSelect.value.trim()
  }

  return null
}

/**
 * Gets the featured media ID for the current variant
 * Looks for variant data in a hidden JSON script tag
 */
function getFeaturedMediaIdForVariant() {
  // Get the currently selected variant ID
  const variantIdInput = document.querySelector('input[name="id"]')
  if (!variantIdInput || !variantIdInput.value) {
    return null
  }

  const currentVariantId = variantIdInput.value

  // Look for variant data in the page (usually in a script tag)
  const variantScript = document.querySelector('script[type="application/json"][data-product-variants]')
  if (!variantScript) {
    return null
  }

  try {
    const variants = JSON.parse(variantScript.textContent)
    const variant = variants.find((v) => v.id == currentVariantId)
    return variant?.featured_media?.id || null
  } catch (e) {
    console.error("[v0] Error parsing variant data:", e)
    return null
  }
}

/**
 * Filters media slides by color/variant alt text
 * Shows images with matching alt text, hides others (except those without alt)
 */
function filterMediaByColor(color) {
  if (!color) return

  const selected = color.toLowerCase()

  // Filter main gallery slides (.js-media-list)
  document.querySelectorAll(".js-media-list .swiper-slide").forEach((slide) => {
    const img = slide.querySelector("img")
    const alt = (img?.getAttribute("alt") || "").toLowerCase()

    // If no alt text, keep visible (lifestyle/dimensions/etc.)
    if (!alt) {
      slide.style.display = ""
      return
    }

    // Show if alt contains the selected variant
    slide.style.display = alt.includes(selected) ? "" : "none"
  })

  // Filter thumbnail/sub-gallery slides (.js-media-sublist)
  document.querySelectorAll(".js-media-sublist .swiper-slide").forEach((slide) => {
    const img = slide.querySelector("img")
    const alt = (img?.getAttribute("alt") || "").toLowerCase()

    if (!alt) {
      slide.style.display = ""
      return
    }

    slide.style.display = alt.includes(selected) ? "" : "none"
  })
}

/**
 * Moves the featured media slide to the first position
 * Uses the data-media-id or data-media-sub-id to identify featured slides
 */
function moveFeatureMediaToFirst(sliderSelector, featuredMediaId) {
  if (!featuredMediaId) return

  const sliderEl = document.querySelector(sliderSelector)
  if (!sliderEl) return

  const slides = sliderEl.querySelectorAll(".swiper-slide")
  let featuredSlide = null
  let featuredIndex = -1

  // Find the slide matching the featured media ID
  slides.forEach((slide, index) => {
    const dataMediaId = slide.getAttribute("data-media-id") || slide.getAttribute("data-media-sub-id") || ""
    // The featured media ID might be in format like "section-123-media-456"
    if (dataMediaId.includes(String(featuredMediaId))) {
      featuredSlide = slide
      featuredIndex = index
    }
  })

  // If not found by ID, look for explicitly marked featured slide
  if (!featuredSlide) {
    slides.forEach((slide, index) => {
      const position = slide.getAttribute("data-position")
      if (position === "featured") {
        featuredSlide = slide
        featuredIndex = index
      }
    })
  }

  // Move the featured slide to the beginning of the DOM
  if (featuredSlide && featuredIndex > 0) {
    sliderEl.insertBefore(featuredSlide, sliderEl.firstChild)
  }
}
function syncThumbClicks() {
  const main = document.querySelector(".js-media-list")?.swiper
  const thumbs = document.querySelector(".js-media-sublist")?.swiper

  if (!main || !thumbs) return

  thumbs.slides.forEach((thumbSlide) => {
    thumbSlide.onclick = null

    thumbSlide.addEventListener("click", (e) => {
      e.preventDefault()

      if (thumbSlide.style.display === "none") return

      // Get index of this thumb among VISIBLE thumbs
      const visibleThumbs = thumbs.slides.filter(
        (s) => s.style.display !== "none"
      )

      const visibleIndex = visibleThumbs.indexOf(thumbSlide)

      if (visibleIndex === -1) return

      main.slideTo(visibleIndex)
    })
  })
}

/**
 * Main filter function that coordinates all operations
 * Called when variant changes or page loads
 */
function runFilter() {
  const selectedColor = getSelectedColor()

  filterMediaByColor(selectedColor)

  const featuredMediaId = getFeaturedMediaIdForVariant()
  moveFeatureMediaToFirst(".js-media-list", featuredMediaId)
  moveFeatureMediaToFirst(".js-media-sublist", featuredMediaId)

  const mainSwiperEl = document.querySelector(".js-media-list")
  const subSwiperEl = document.querySelector(".js-media-sublist")

  if (mainSwiperEl?.swiper) {
    mainSwiperEl.swiper.slideTo(0)
    mainSwiperEl.swiper.update()
  }

  if (subSwiperEl?.swiper) {
    subSwiperEl.swiper.slideTo(0)
    subSwiperEl.swiper.update()
  }
  syncThumbClicks()

}

// Run filter on page load
document.addEventListener("DOMContentLoaded", runFilter)

// Run filter whenever a variant option changes (radio, dropdown, or custom)
document.addEventListener("change", (e) => {
  const isVariantControl =
    e.target.closest("variant-radios") || e.target.closest("variant-selects") || e.target.closest(".product-form")

  if (isVariantControl) {
    runFilter()
  }
})
